<!--订单发起采购页面-->
<template>
  <el-dialog :title="title" :visible.sync="dialogSeeVisible" center :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true" custom-class="max-dialog1256" >
    <el-form :model="form" ref="form1" >
    <el-row :gutter="24">
      <el-col :span="16">
        <el-form-item label="客户" :label-width="formLabelWidth">
          <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true" :needfocus="false"></AutoCustomer>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode">
          <el-select v-model="form.cangkucode" placeholder="请选择" filterable style="width: 150px" size="mini" >
            <el-option  v-for="item in jxcstoreData" v-if="item.cangkucode!=''" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--<el-col :span="24">-->
        <!--<el-form-item label="地址" :label-width="formLabelWidth">-->
        <!--<span v-if="customer">{{customer.deliveryaddress}}（{{customer.linkman}} {{customer.linkmantel}}）</span>-->
        <!--</el-form-item>-->
      <!--</el-col>-->
      <el-col :span="24">
        <el-form-item label="商品" :label-width="formLabelWidth">
          <el-table :data="goodsdata" size="mini" stripe border style="width: 100%;" height="500">
            <el-table-column
              label="商品名称"
              align="left" width="260" :show-overflow-tooltip="true"
              header-align="center">
              <template slot-scope="scope">
                {{scope.row.seedname}}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="数量"
              align="left"
              header-align="center"
              width="140">
              <template slot-scope="scope">
                <el-input-number style="width: 100%" size="mini" v-model="scope.row.totalnumber" :min="0" :precision="0" onfocus="this.select()" @change="settotalNumber"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="pcostprice"
              label="单价"
              align="left"
              header-align="center"
              width="140">
              <template slot-scope="scope">
                {{scope.row.pcostprice}} 元/{{scope.row.seedunit||'副'}}
              </template>
            </el-table-column>
            <el-table-column
              label="总价"
              align="left"
              header-align="center"  width="140">
              <template slot-scope="scope">
                {{parseFloat(scope.row.totalnumber)*parseFloat(scope.row.pcostprice?scope.row.pcostprice:0)}}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="totalnum==1">
        <el-form-item label="配镜单" :label-width="formLabelWidth">
          <RLTable ref="RLTable1"></RLTable>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="备注" :label-width="formLabelWidth" prop="comment2">
          <el-input v-model="form.comment2" auto-complete="off" type="textarea" size="mini"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <div>总数：{{totalnum}}</div>
        <div>总价：{{totalprice}}</div>
      </el-col>
    </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer no-print">
      <MachiningBatchPrint ref="MachiningBatchPrint1" ></MachiningBatchPrint>
      <el-button @click="dialogSeeVisible=false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="saveData(true)" v-if="logintoken">生成订单（按数量拆）</el-button>
      <el-button type="success" :loading="loading" @click="saveData(false)" v-if="logintoken">生成订单（不拆分）</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoods4app} from '@/api/set/jxcgooddetail';
  import {sofortkaufentoken} from '@/api/order/shopping'
  import {simulationLogin} from '@/api/login';
  import  MachiningBatchPrint from './MachiningBatchPrint';
  import RLTable from '@/components/set/goodsprice/RLTable';

  export default {
    name: 'MachiningBacth',
    data() {
      return {
        title: '加工单批量下单',
        loading: false,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        goodsdata: [],
        totalnum: 0,
        totalprice: 0,
        logincustomer: {},
        jxcstoreData:[],
        logintoken: '',
        form: {
          comment2: '',
          cangkucode:''
        },
        customer:{}
      }
    },
    props: {},
    methods: {
      //客户地址
      select(customerserial, customername, row) {
        this.customer=row;
        this.goodsdata=[];
        simulationLogin({loginName: '', customerserial: row.customerserial}).then(resLog => {
          if (resLog.data.code == 0) {
            var sm=resLog.data.obj.memberDO.settingmenthod;
            if(!(sm.includes('200') && !sm.includes('100'))) {
              this.logincustomer = null;
              this.logintoken = "";
              return;
            }
            this.logincustomer = resLog.data.obj;
            this.logintoken = resLog.data.token;
            listgoods4app({
              seedname: "",
              enable: 1,
              offset: 0,
              limit: 50,
              filltemplates: 50
            }, this.logintoken).then(resGoods => {
              var row = resGoods.data.obj.rows;
              for (let i in row) {
                row[i].totalnumber = 0;
              }
              this.goodsdata = row;
            });
          } else {
            this.$alert(resLog.data.msg, '异常', {
              confirmButtonText: '确定', type: 'error', callback: action => {
                this.focusinput();
              }
            });
          }
        });
      },
      show() {
        this.dialogSeeVisible = true
        this.initform();
        if (this.jxcstoreData.length == 0) {
          this.BindStore();
        }
      },
      initform() {
        this.loading = false;
        this.goodsdata = [];
        this.totalnum = 0;
        this.totalprice = 0;
        this.form.comment2='';
        this.logincustomer = {};
        this.logintoken = '';
        if(this.$refs.RLTable1)
          this.$refs.RLTable1.reset();
        this.customer={};
      },
      settotalNumber(){
        this.totalnum = 0
        this.totalprice = 0;
        for (let i in this.goodsdata) {
          if (this.goodsdata[i].totalnumber)
            this.totalnum = this.totalnum + parseInt(this.goodsdata[i].totalnumber)
          if (this.goodsdata[i].totalnumber && this.goodsdata[i].pcostprice) {
            this.totalprice += parseFloat(this.goodsdata[i].totalnumber) * parseFloat(this.goodsdata[i].pcostprice);
          }
        }
        this.totalprice = this.totalprice.toFixed(2);
      },
      //根据登录人过滤仓库
      BindStore() {
        cusandptbyind({thirdstore: 0}).then(response => {
          this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
          this.jxcstoreData = response.data.obj;
          if (this.jxcstoreData.length > 0) {
            this.form.cangkucode = this.jxcstoreData[0].cangkucode;
          }
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.form.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }
          }
        })
      },
      postData(cangkuname,formdata,index,erpserial){
        if(index==formdata.length) {
          this.initform();
          if (erpserial)
            this.lookDetails({erpserial: erpserial});
          this.$emit('bindGrid');
          return;
        }
      },
      saveData(split) {
        // this.$refs.MachiningBatchPrint1.show('4125b8bb-6419-4267-8c1b-ffabf036a20f;678a0a28-2c84-48cc-a87e-bba1bc9d8ea4;93711ed8-4d83-4dd0-acef-b131e3ac28d5');
        // return;

        this.loading = true;
        var arr = [];
        var chufangdan='';
        if(this.totalnum==1){
          chufangdan=  this.$refs.RLTable1.RLstring();
        }
        for (let i in this.goodsdata) {
          if (this.goodsdata[i].totalnumber > 0) {
            var nums = this.goodsdata[i].totalnumber;
            if (split) {
              for (var j = 0; j < nums; j++) {
                var obj = {}
                obj.seedcode = this.goodsdata[i].seedcode;
                obj.Number = 1;
                obj.type = "M";
                if (chufangdan) {
                  obj["处方单"] = chufangdan;
                }
                arr.push(obj);
              }
            } else {
              var obj = {}
              obj.seedcode = this.goodsdata[i].seedcode;
              obj.Number = nums;
              obj.type = "M";
              if (chufangdan) {
                obj["处方单"] = chufangdan;
              }
              arr.push(obj);
            }
          }
        }
        if(arr.length==0){
          this.$message({type: 'error',message: '未选择商品!'});
          this.loading = false;
          return;
        }
        var cangkuname ='';
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == this.form.cangkucode) {
            cangkuname = this.jxcstoreData[i].cangkuname;
            break;
          }
        }

        var shoppingdata = {
          openurl: '',
          formproperty: JSON.stringify(arr),
          formtype: 42,
          seedcode: 'machinebatch',
          sendername: '',
          senderserial: '',
          tracknum: '',
          totalnumber: 1,
          remark: this.form.comment2,
          deliveryaddress:  this.customer.deliveryaddress,
          linkmantel: this.customer.linkmantel,
          linkman: this.customer.linkman,
          settingmenthod: 200,
          shipnow: 3,//推送到加工
          cangkucode: this.form.cangkucode,
          cangkuname: cangkuname
        }
        sofortkaufentoken(shoppingdata, this.logintoken).then((response) => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '订单创建成功!'
            });
            var unitguids= response.data.unitguids;
            this.$refs.MachiningBatchPrint1.show(unitguids);
            this.$emit("bindGrid");
            this.$refs.autocustomer.clearContent();
            this.initform();

          } else {
            this.$message({
              type: 'error',
              message: '生成订单失败!'
            });
          }
        })
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      this.userInfoModel = JSON.parse(temp);
    },
    components: {
      MachiningBatchPrint,
      RLTable
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/MachiningBacth.vue